/**
 * Format Value With Unit Utility
 *
 * Utility function for formatting value with unit
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

/**
 * Format value with unit
 */
export const formatValueWithUnit = (
	value: string | number | undefined,
	unit: string = 'px',
): string => {
	if ( ! value || value === '' ) return '';
	if ( value === 'auto' ) return 'auto';

	// Convert to string for processing
	const stringValue = String( value );

	// If value already has a unit, return as is
	if ( /[a-zA-Z%]/.test( stringValue ) ) {
		return stringValue;
	}

	// Add unit to numeric values
	return `${ stringValue }${ unit }`;
};
